import { Link } from "react-router-dom";
import { Hero } from "../components/home/Hero";
import { Intro } from "../components/home/Intro";
import { ServicesPreview } from "../components/home/ServicesPreview";
import { Process } from "../components/home/Process";
import { ProjectGrid } from "../components/ProjectGrid";
import { Reveal, SectionHeading } from "../components/Reveal";
import { Marquee } from "../components/Marquee";
import { CollabCTA } from "../components/CollabCTA";
import { useSite } from "../context/SiteContext";
import { useSeo } from "../lib/useSeo";

const FeaturedWork = () => {
  const { projects } = useSite();
  const featured = projects.filter((p) => p.featured).slice(0, 6);
  if (!featured.length) return null;
  return (
    <section data-testid="featured-work-section" className="mx-auto max-w-[1400px] px-6 pb-28 md:px-10 md:pb-40">
      <div className="mb-20 flex flex-col justify-between gap-8 md:flex-row md:items-end">
        <SectionHeading eyebrow="Selected Creations" title={<>Our Work <span className="italic">Speaks Visually.</span></>} />
        <Reveal className="max-w-xs text-sm leading-relaxed text-muted-ink">
          Makeup, beauty, jewellery and product films — each one labelled honestly as a concept, personal project or collaboration.
        </Reveal>
      </div>
      <ProjectGrid projects={featured} testid="featured-work-grid" />
      <Reveal className="mt-24 flex justify-center">
        <Link to="/portfolio" className="btn btn-primary" data-testid="view-full-portfolio-btn">View Full Portfolio</Link>
      </Reveal>
    </section>
  );
};

export default function Home() {
  useSeo(
    "Luxury Image & Video Ads for Beauty and Jewellery Brands",
    "BWI is a creative studio in India crafting luxury product photography and cinematic video ads for makeup, skincare, beauty and jewellery brands worldwide."
  );
  return (
    <>
      <Hero />
      <Intro />
      <FeaturedWork />
      <Marquee />
      <ServicesPreview />
      <Process />
      <CollabCTA />
    </>
  );
}
